// SessionLimitBanner — soft enforcement of plan device limits.
//
// Renders only when `useActiveSession` reports the user is over their limit.
// Tells them what's happening; does not hard-block (that's a Phase 2 call).
// Mounted once at the App root so every signed-in page sees it.

import { ShieldAlert } from "lucide-react";
import { useActiveSession } from "@/hooks/useActiveSession";

export default function SessionLimitBanner() {
  const session = useActiveSession();
  if (!session || session.allowed) return null;
  if (session.currentPlan !== "pro" && session.currentPlan !== "elite") return null;

  return (
    <div className="fixed top-2 inset-x-2 z-50 rounded-xl border border-destructive/40 bg-destructive/10 backdrop-blur px-3 py-2 shadow-lg">
      <div className="flex items-start gap-2">
        <ShieldAlert className="w-4 h-4 text-destructive mt-[1px] shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="text-[12px] font-display font-semibold text-destructive leading-snug">
            Account active on {session.activeCount} devices
          </p>
          <p className="text-[10.5px] font-body text-foreground/80 leading-snug mt-0.5">
            Your {session.currentPlan.toUpperCase()} plan allows {session.planLimit} active device
            {session.planLimit === 1 ? "" : "s"}. Sign out elsewhere to keep using Decyzon here.
          </p>
        </div>
      </div>
    </div>
  );
}
